var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartTv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 32.5C31.875 33.5355 31.0355 34.375 30 34.375C28.9645 34.375 28.125 33.5355 28.125 32.5C28.125 31.4645 28.9645 30.625 30 30.625C31.0355 30.625 31.875 31.4645 31.875 32.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6065 21.8934C37.892 19.1789 34.142 17.5 29.9999 17.5C25.8578 17.5 22.1078 19.1789 19.3933 21.8934M24.6966 27.1967C26.0538 25.8395 27.9288 25 29.9999 25C32.071 25 33.946 25.8395 35.3032 27.1967M17.5 52.5C26.9187 49.1883 32.3233 49.1451 42.5 52.5M30 50V42.5M5 17.5L5 32.5C5 38.0228 9.47715 42.5 15 42.5L45 42.5C50.5228 42.5 55 38.0229 55 32.5V17.5C55 11.9772 50.5228 7.5 45 7.5L15 7.5C9.47715 7.5 5 11.9772 5 17.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartTv);
export default __webpack_public_path__ + "static/media/smart-tv.5edab1b5fa51ef4f625fb9d9780acd47.svg";
export { ForwardRef as ReactComponent };